const KEY = 'event-platform:selected-org'

export const tenantStorage = {
  get: () => localStorage.getItem(KEY),
  set: (id: string) => localStorage.setItem(KEY, id),
  clear: () => localStorage.removeItem(KEY),
}
